<template>
  <block-item-card
    ref="descriptiveStatistics"
    :base-currency-symbol="riskBaseCurrencyDisplayName"

    :title="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Title')"
    :title-value-color-red="false"
  >
    <v-card-text
      class="pb-2 "
    >
      <item-chart-legend
        :key="`alm-loans-portfolio-descriptive-statistics-legend-size`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Size.Description')"
        :base-currency-symbol="riskBaseCurrencyDisplayName"
        :title="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Size.Title')"
        :title-value="sizeValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />

      <item-chart-legend
        :key="`alm-loans-portfolio-descriptive-statistics-legend-loans`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Loans.Description')"
        :title="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Loans.Title')"
        :title-value="loansValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />

      <item-chart-legend
        :key="`alm-loans-portfolio-descriptive-statistics-legend-maturity`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Maturity.Description')"
        :title="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Maturity.Title')"
        :title-value="maturityValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
      <item-chart-legend
        :key="`alm-loans-portfolio-descriptive-statistics-legend-repricing`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Repricing.Description')"
        :title="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Repricing.Title')"
        :title-value="repricingValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
      <item-chart-legend
        :key="`alm-loans-portfolio-descriptive-statistics-legend-loans-value`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.LoansValue.Description')"
        :base-currency-symbol="riskBaseCurrencyDisplayName"
        :title="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.LoansValue.Title')"
        :title-value="loansValueValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
      <item-chart-legend
        :key="`alm-loans-portfolio-descriptive-statistics-legend-duration`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Duration.Description')"
        :title="$t('ALM.Section.LoansPortfolio.DescriptiveStatistics.Duration.Title')"
        :title-value="durationValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
    </v-card-text>
  </block-item-card>
</template>
<script>
import BlockItemCard      from '@/theme/default/components/common/BlockItemCard'
import ItemChartLegend    from '@/theme/default/components/common/ItemChartLegend'
import baseEChartColors   from '@/theme/default/components/charts/echarts/mixins/common/baseEChartColors'
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import riskBaseCurrency   from '@/theme/default/views/risks/mixins/riskBaseCurrency'
import { toNumberFormatNotationShort, toDecimalSignificant } from '@/lib/utils/helper'
import riskAnalysisId from '@/theme/default/views/risks/mixins/riskAnalysisId'

export default {
  name      : 'ALMLoansDescriptiveStatistics',
  components: { BlockItemCard, ItemChartLegend },
  directives: {},
  mixins    : [i18nRouteMeta, riskBaseCurrency, baseEChartColors, riskAnalysisId],
  props     : {},
  dataStore : {
    appToolbarExtended: 'App.Config.AppToolbarExtended',

    Loans: 'ALM.Loans.Data',

    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'
  },
  enums: {},
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364
    }
  },
  computed: {
    descriptiveStatistics () {
      return this.Loans.DescriptiveStatistics || null
    },
    sizeValue () {
      return this.descriptiveStatistics.size ? toNumberFormatNotationShort(this.descriptiveStatistics.size) : ''
    },
    loansValue () {
      return this.descriptiveStatistics.loans ? this.descriptiveStatistics.loans.toLocaleString('en-US') : ''
    },
    maturityValue () {
      return this.descriptiveStatistics.maturity ? toDecimalSignificant(this.descriptiveStatistics.maturity) + ' ' + this.descriptiveStatistics.maturityUnit : ''
    },
    repricingValue () {
      return this.descriptiveStatistics.repricing ? toDecimalSignificant(this.descriptiveStatistics.repricing) + ' ' + this.descriptiveStatistics.repricingUnit : ''
    },
    loansValueValue () {
      return this.descriptiveStatistics.value ? toNumberFormatNotationShort(this.descriptiveStatistics.value) : ''
    },
    durationValue () {
      return this.descriptiveStatistics.duration ? toDecimalSignificant(this.descriptiveStatistics.duration) + ' ' + this.descriptiveStatistics.durationUnit : ''
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }

  },
  created () {
  },
  beforeMount () {},
  mounted () {
  },
  beforeUpdate () {},
  updated () {},
  destroyed () {},
  methods: {

  }
}
  </script>

  <style scoped>

  </style>
